import React from 'react';
import FullscreenAdminShell from '../AdminSocialReviewerPage/FullscreenAdminShell';
import StudioClientOnly from './StudioClientOnly';
import { loadData } from '../AdminSocialPostsPage/AdminSocialPostsPage.duck';

/**
 * AdminSocialWorkflowPage — the full-screen Workflow Studio, opened from the
 * Workflow-tab list (route /admin-social/workflow/:slug).
 *
 * It reuses the same chrome-less FullscreenAdminShell as the reviewer (one shell,
 * not two): admin gating + currentUser/history injection, no Topbar/Footer. The
 * animated + DOM-reaching subtree (framer-motion chrome + the reactflow editor)
 * lives behind StudioClientOnly so it never runs during SSR.
 *
 * The `:slug` route param selects the active workflow by permanent opaque URL
 * handle. The editor uses the returned workflow's trigger internally.
 */
const AdminSocialWorkflowPage = props => {
    const slug = (props.params && props.params.slug) || '';
    return (
        <FullscreenAdminShell
            title="AdminSocialWorkflowPage"
            schema={{
                '@context': 'http://schema.org',
                '@type': 'AdminSocialWorkflowPage',
                description: 'Social media workflow studio',
                name: 'Admin panel',
            }}
        >
            <StudioClientOnly slug={slug} />
        </FullscreenAdminShell>
    );
};

// Reuse the dashboard loadData (client-only, admin-cookie authenticated). The
// Studio's WorkflowEditor fetches the trigger's workflow itself on mount.
AdminSocialWorkflowPage.loadData = loadData;

export default AdminSocialWorkflowPage;
